import transcodingStatuses from '../../constants/transcoding-statuses';
import channels from './channels/channels';

import events from './events/index';
import wixmp from 'wixmp-sdk';


const itemsTranscodingStatuses = {};

const LISTENER_NAME = 'transcoding';

const TRANSCODING_PROGRESS_STATUSES = [
  transcodingStatuses.IN_QUEUE,
  transcodingStatuses.PENDING,
  transcodingStatuses.INPROGRESS,
  transcodingStatuses.PREVIEW_READY,
];


function isNotInTranscoding(transcodingStatus) {
  return !_.includes(TRANSCODING_PROGRESS_STATUSES, transcodingStatus);
}

function stopListenTranscoding() {
  if (_.every(itemsTranscodingStatuses, isNotInTranscoding)) {
    channels.stopListen(LISTENER_NAME);
  }
}

if (wixmp) {
  wixmp.events.on(wixmp.events.ITEM.UPDATE, function (eventPromise, event) {
    if (event.eventTarget !== channels.privateMedia) {
      return;
    }

    eventPromise.then(function ({ data }) {
      // don't remove this console.info call for now
      console.info('CHANNELS API', data); // eslint-disable-line no-console

      const transcodingStatus = data.transcodingStatus.toUpperCase();
      itemsTranscodingStatuses[data.id] = transcodingStatus;

      events.trigger(events.TRANSCODING.UPDATE, {
        id: data.id,
        transcodingStatus,
      });
      stopListenTranscoding();
    });
  });
}

export default function triggerProgressWhileTranscoding(items) {
  // TODO: handle small files uploading

  if (items) {
    if (_.every(items, function ({ transcodingStatus, trailerTranscodingStatus }) {
        return isNotInTranscoding(transcodingStatus) && isNotInTranscoding(trailerTranscodingStatus);
      })) {
      return;
    }

    _.forEach(items, function ({ mediaFileName, trailerFileName, transcodingStatus, trailerTranscodingStatus }) {
      if (mediaFileName) {
        itemsTranscodingStatuses[mediaFileName] = transcodingStatus;
      }
      if (trailerFileName) {
        itemsTranscodingStatuses[trailerFileName] = trailerTranscodingStatus;
      }
    });
  }

  channels.startListen(LISTENER_NAME);
}



// WEBPACK FOOTER //
// ./src/transport/adapters/vod/trigger-progress-while-transcoding.js